<app-mwe-table [columns]="columns" [data]="data" [showPagination]="false" [showHeader]="false" (selectedAction)="selectedAction($event)" [totalEntries]="totalEntries"
></app-mwe-table>
<form [formGroup]="contactsForm">
    <div class="card p-4 mt-2 mb-2" *ngIf="isProceed">
        <div class="row mt-2" >
            <div class="col-lg-3 my-2">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Select Continent<span class="text-danger">*</span></p>
          
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <input 
                      matInput 
                      [matAutocomplete]="continentAuto" 
                      placeholder="Choose Continent"
                      [formControl]="continentControl"
                      (input)="onInputChangeContinent($event)" 
                      (blur)="validateInputContinent()"
                      (focus)="onFocusInput()"
                      #continentInput
                      #continentTrigger="matAutocompleteTrigger" required >
                  
                    <mat-autocomplete #continentAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'continent')">
                      <mat-option *ngFor="let continent of filteredContinents" [value]="continent.continentName">
                        {{ continent?.continentName }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error class="error-message error-msg " *ngIf="contactsForm.get('continent')?.hasError('required') " >
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Continent is required
                    </mat-error>
                  </mat-form-field>
       
            </div>
       
            <div class="col-lg-3 my-2">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Select Country<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <input 
                      matInput 
                      [matAutocomplete]="countryAuto" 
                      placeholder="Enter Country"
                      [formControl]="countryControl"
                      (input)="onInputChangeCountry($event)" 
                      (blur)="validateInputCountry()"
                      (focus)="onFocusInput()"
                      #countryInput
                      #countryTrigger="matAutocompleteTrigger" required>
                  
                    <mat-autocomplete #countryAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'country')">
                      <mat-option *ngFor="let country of filteredCountries" [value]="country.countryName">
                        {{ country?.countryName }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error class="error-message error-msg " *ngIf="contactsForm.get('country')?.hasError('required') ">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> country is required
                    </mat-error>
                  </mat-form-field>
            </div>
            <div class="col-lg-3 my-2">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Select State<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <input 
                      matInput 
                      [matAutocomplete]="statesAuto" 
                      placeholder="Enter state"
                      [formControl]="stateControl"
                      (input)="onInputChangeState($event)" 
                      (blur)="validateInputState()"
                      (focus)="onFocusInput()"
                      #stateInput
                      #stateTrigger="matAutocompleteTrigger" required>
                  
                    <mat-autocomplete #statesAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'state')">
                      <mat-option *ngFor="let state of filteredStates" [value]="state.stateName">
                        {{ state?.stateName }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error class="error-message error-msg " *ngIf="contactsForm.get('state')?.hasError('required') ">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> State is required
                    </mat-error>
                  </mat-form-field>
            </div>
            <div class="col-lg-3 my-2">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Select City<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <input 
                      matInput 
                      [matAutocomplete]="cityAuto" 
                      placeholder="Enter city"
                      [formControl]="cityControl"
                      (input)="onInputChangeCity($event)" 
                      (blur)="validateInputCity()"
                      (focus)="onFocusInput()"
                      #stateInput
                      #stateTrigger="matAutocompleteTrigger" required>
                  
                    <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'city')">
                      <mat-option *ngFor="let city of filteredCities" [value]="city.cityName">
                        {{ city?.cityName }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error class="error-message error-msg " *ngIf="contactsForm.get('state')?.hasError('required') ">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> city is required
                    </mat-error>
                  </mat-form-field>
            </div>
        </div>
    <div class="row mt-2 errorMessage-laptop ">
        <div class="col-lg-3 my-2">
            <div >
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Employee Name<span class="text-danger">*</span></p>
            </div>
            <div>
                <mat-form-field appearance="outline" class="fields input-font w-100 ">
                    <input matInput placeholder="Enter Name"  formControlName="employeeName" (keypress)="onlyText($event)" (blur)="contactsForm.get('employeeName')?.markAsTouched()">
                    <mat-error class="error-message error-msg " 
                    *ngIf="contactsForm.get('employeeName')?.hasError('required')" 
                   >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                    Employee Name is required
                  </mat-error>
            
                  <mat-error class="error-message error-msg " 
                    *ngIf="contactsForm.get('employeeName')?.hasError('maxlength') && contactsForm.get('employeeName')?.touched" 
                    >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                    Limit Exceeded : Max 50 characters
                  </mat-error>
                </mat-form-field>
            </div>
        </div>
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Employee Position<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 ">
                <input matInput placeholder="Enter Position" formControlName="employeePosition" (keypress)="onlyText($event)" (blur)="contactsForm.get('employeePosition')?.markAsTouched()">
                <mat-error class="error-message error-msg " *ngIf="contactsForm.get('employeePosition')?.hasError('required')">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Employee Position is required
                </mat-error>
                <mat-error class="error-message error-msg " *ngIf="contactsForm.get('employeePosition')?.hasError('maxlength') && contactsForm.get('employeePosition')?.touched && !contactsForm.get('employeePosition')?.hasError('required')">
                    <img class="error-icon" style="margin-right:5px;" loading="lazy" alt="" src="./../../assets/images/alert.svg" />Limit Exceeded : Max 50 characters
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Email<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 ">
                <input matInput placeholder="Enter Email" formControlName="email" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" (blur)="contactsForm.get('email')?.markAsTouched()">
                <mat-error class="error-message error-msg "
                    *ngIf="contactsForm.get('email')?.hasError('required') || contactsForm.get('email')?.hasError('pattern') && contactsForm.get('email')?.touched"><img
                        class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" style="margin-right: 6px;"/>Enter a valid Email
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Phone Number<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 ">
                <input matInput placeholder="Enter Phone" formControlName="phone"   (blur)="contactsForm.get('phone')?.markAsTouched()">
                <mat-error class="error-message error-msg " *ngIf="contactsForm.get('phone')?.hasError('required')" >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is Required
                </mat-error>
                <mat-error class="error-message error-msg " *ngIf="contactsForm.get('phone')?.hasError('minlength') && !contactsForm.get('phone')?.hasError('required') && contactsForm.get('phone')?.touched" >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Enter Atleast 10 digits
                </mat-error>
                <mat-error class="error-message error-msg " *ngIf="contactsForm.get('phone')?.hasError('maxlength') && !contactsForm.get('phone')?.hasError('required') && contactsForm.get('phone')?.touched">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Limit Exceeded : Max 15 digits
                </mat-error>
                <mat-error class="error-message error-msg " *ngIf="contactsForm.get('phone')?.hasError('pattern') && !contactsForm.get('phone')?.hasError('required') && contactsForm.get('phone')?.touched">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />  Enter a valid Phone Number
                </mat-error>
            </mat-form-field>
        </div>
    </div>
   
</div>
        <br>

<div class="mt-2">

    <button class="mwe-button mwe-button--primary ps-3 pe-3" (click)="addBranchInformation()"
       >
        <span class="deltext">Save</span>
        
    </button>&nbsp;&nbsp;
    <button class="mwe-button mwe-button--secondary ps-3 pe-3" (click)=" toggleCancel()"
    >
     <span class="deltext">Cancel</span>
 </button>
</div>
    </div>

    <div *ngIf="!isProceed&&!isMore" class="mt-2 mb-2" style="margin-left: 10px;">
        <button class="d-flex more" (click)=" toggleIsProceed()"
        ><mat-icon>add</mat-icon>
         <span class="deltext">Add</span>
     </button>
    </div>
    <div *ngIf="!isProceed&&isMore" class="mt-2 mb-2" style="margin-left: 10px;" >
     <button class="d-flex more" (click)="toggleIsProceed()"
     ><mat-icon>add</mat-icon>
      <span class="deltext">Add More</span>
  </button>
</div>
</form>